import React from 'react';
import VideoTwo from '../video/VideoTwo';
import { FiCheck } from "react-icons/fi";
import { FiArrowRight } from "react-icons/fi";
import {Link} from "react-router-dom";


const PopupData = [
    {
        id: "01",
        image: "./images/bg/bg-image-4.jpg",
        popupLink: [
            'https://www.youtube.com/watch?v=2rsI05vBsD4',
        ],
    }
]

const AboutFour = ({image}) => {
    return (
        <div className="about-area about-style-4 rn-section-gap">
            <div className="container">
                <div className="row row--40 align-items-center">
                    <div className="col-lg-6">
                        {PopupData.map((item) => (
                            <div className="video-btn" key={item.id}>
                                <VideoTwo imagename={`${image}`} galleryItem={item} />
                            </div>
                        ))}
                    </div>
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="inner">
                                <h3 className="title">Suntem specializați<br /> in oferirea serviciilor ce au legătură cu <strong>implementarea soluțiilor software.</strong></h3>
                                <ul className="feature-list">
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">Analiza pieței și a cerințelor clientului</h4>
                                            <p className="text">
                                                Analizăm nevoile și cerințele clienților noștri, pentru a oferi soluții software personalizate ce includ piața și cerințele actuale.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">Implementare software și testare</h4>
                                            <p className="text">
                                                Implementăm și dezvoltăm soluții software personalizate, pe care le testăm și le optimizăm pentru a oferi cele mai bune rezultate.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="about-btn mt--30">
                                    
                                    <Link className="btn-default " to="/pricing">Obține o ofertă<i className="icon"><FiArrowRight /></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutFour
